<template>
  <div class="p-4">
    <div class="flex items-center gap-4">
      <div class="tb-form-group flex-1 min-w-0 max-w-md">
        <label class="tb-label">
          Title
        </label>

        <input
          v-model="markerTitle"
          class="tb-input"
          data-test="marker-editor-title"
          type="text"
          @blur="saveMarker"
          @keyup.enter="saveMarker"
        >
      </div>

      <div class="tb-form-group shrink-0">
        <colorpicker
          :color="markerColor"
          :large="true"
          data-test="marker-editor-color"
          show-buttons
          @change="onMarkerColorChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_MARKER_COLOR = '#CC9F10';

export default {
  name: 'MarkerEditor',

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      markerTitle: '',
      markerColor: DEFAULT_MARKER_COLOR,
    };
  },

  watch: {
    item: {
      immediate: true,
      handler(item) {
        this.markerTitle = item?.title || '';
        this.markerColor = item?.fields?.color || item?.color || DEFAULT_MARKER_COLOR;
      },
    },
  },

  methods: {
    saveMarker() {
      const title = String(this.markerTitle || '').trim();
      if (!title) {
        this.markerTitle = this.item.title || '';
        return;
      }

      this.$set(this.item, 'title', title);

      if (!this.item.fields) {
        this.$set(this.item, 'fields', {});
      }

      this.$set(this.item.fields, 'color', this.markerColor || DEFAULT_MARKER_COLOR);

      this.$store.dispatch('updateTimeline');
    },

    onMarkerColorChange(color) {
      this.markerColor = color || DEFAULT_MARKER_COLOR;
      this.saveMarker();
    },
  },
};
</script>
